import AppUserProfile from "./AppUserProfile";

export const TicketPhase = Object.freeze({
  All: { value: "ALL" },
  Proposal: { value: "PROPOSAL" },
  Claim: { value: "CLAIM" },
  Management: { value: "MANAGEMENT" },
  Accounting: { value: "ACCOUNTING" },
});

export const stringToTicketPhase = (phaseString) => {
  const phase = Object.entries(TicketPhase).find(
    ([, value]) => value.value === phaseString.toUpperCase()
  );

  return phase ? TicketPhase[phase[0]] : null;
};

export const TicketStatus = Object.freeze({
  All: { value: "ALL" },
  Cancelled: { value: "CANCELLED" },
  AwaitingApproval: { value: "AWAITING_APPROVAL" },
  AwaitingReview: { value: "AWAITING_REVIEW" },
  AwaitingOther: { value: "AWAITING_OTHER" },
  Approved: { value: "APPROVED" },
  Rejected: { value: "REJECTED" },
  Paid: { value: "PAID" },
  Edit: { value: "EDIT" },
});

export const stringToTicketStatus = (statusString) => {
  const status = Object.entries(TicketStatus).find(
    ([, value]) => value.value === statusString.toUpperCase()
  );

  return status ? TicketStatus[status[0]] : null;
};

export const fallBackTicketStatus = [
  { id: TicketStatus.AwaitingApproval, name: "รอการอนุมัติ" },
  { id: TicketStatus.Rejected, name: "ไม่ได้รับการอนุมัติ" },
  { id: TicketStatus.Approved, name: "อนุมัติแล้ว" },
  { id: TicketStatus.Cancelled, name: "ยกเลิก" },
];

const ApproverCommonPhaseItems = [
  { id: TicketPhase.All, name: "ทั้งหมด" },
  { id: TicketPhase.Proposal, name: "ข้อเสนอกิจกรรม" },
  { id: TicketPhase.Claim, name: "คำร้องทำจ่าย" },
];

const ApproverClaimStatusItems = [
  {
    id: TicketStatus.All,
    name: "ทั้งหมด",
  },
  { id: TicketStatus.AwaitingApproval, name: "รอการอนุมัติจากคุณ" },
  { id: TicketStatus.AwaitingOther, name: "รอการอนุมัติจากคนอื่น" },
  { id: TicketStatus.Rejected, name: "ไม่ได้รับการอนุมัติ" },
  { id: TicketStatus.Approved, name: "อนุมัติคำขอแล้ว" },
  { id: TicketStatus.Paid, name: "ทำจ่ายแล้ว" },
];
const ApproverProposalStatusItems = [
  {
    id: TicketStatus.All,
    name: "ทั้งหมด",
  },
  { id: TicketStatus.AwaitingApproval, name: "รอการอนุมัติจากคุณ" },
  { id: TicketStatus.AwaitingOther, name: "รอการอนุมัติจากคนอื่น" },
  { id: TicketStatus.Rejected, name: "ไม่ได้รับการอนุมัติ" },
  { id: TicketStatus.Approved, name: "อนุมัติคำขอแล้ว" },
  { id: TicketStatus.Cancelled, name: "คำขอถูกยกเลิก" },
];

const AppTicketConstant = {
  phase: {
    DEALER: [
      { id: TicketPhase.All, name: "ทั้งหมด" },
      { id: TicketPhase.Proposal, name: "ข้อเสนอกิจกรรม" },
      { id: TicketPhase.Claim, name: "คำร้องทำจ่าย" },
      { id: TicketPhase.Accounting, name: "ทำจ่าย" },
    ],
    APPROVER_L1: [
      ...ApproverCommonPhaseItems,
      { id: TicketPhase.Accounting, name: "รอตรวจสอบหลักฐานการจัดกิจกรรม" },
    ],
    APPROVER_L2: ApproverCommonPhaseItems,
    APPROVER_L3: ApproverCommonPhaseItems,
    APPROVER_L4: [
      ...ApproverCommonPhaseItems,
      { id: TicketPhase.Management, name: "จัดการ" },
    ],
    APPROVER_L5: [
      ...ApproverCommonPhaseItems,
      { id: TicketPhase.Management, name: "จัดการ" },
    ],
  },

  ticketStatusOption: {
    DEALER: {
      PROPOSAL: [
        {
          id: TicketStatus.All,
          name: "ทั้งหมด",
        },
        { id: TicketStatus.AwaitingApproval, name: "รอการอนุมัติ" },
        { id: TicketStatus.Rejected, name: "ไม่ได้รับการอนุมัติ" },
        { id: TicketStatus.Approved, name: "อนุมัติคำขอแล้ว" },
        { id: TicketStatus.Cancelled, name: "คำขอถูกยกเลิก" },
      ],
      CLAIM: [
        {
          id: TicketStatus.All,
          name: "ทั้งหมด",
        },
        { id: TicketStatus.AwaitingApproval, name: "รอการอนุมัติทำจ่าย" },
        { id: TicketStatus.Rejected, name: "ไม่ได้รับการอนุมัติทำจ่าย" },
        { id: TicketStatus.Approved, name: "อนุมัติทำจ่ายแล้ว" },
      ],
      MANAGEMENT: [
        {
          id: TicketStatus.All,
          name: "ทั้งหมด",
        },
        { id: TicketStatus.AwaitingApproval, name: "รอการอนุมัติทำจ่าย" },
        { id: TicketStatus.Rejected, name: "ไม่ได้รับการอนุมัติทำจ่าย" },
        { id: TicketStatus.Approved, name: "อนุมัติทำจ่ายแล้ว" },
      ],
      ACCOUNTING: [
        {
          id: TicketStatus.All,
          name: "ทั้งหมด",
        },
        {
          id: TicketStatus.Rejected,
          name: "ไม่อนุมัติทำจ่าย",
        },
        {
          id: TicketStatus.Approved,
          name: "อนุมัติทำจ่ายแล้ว",
        },
        {
          id: TicketStatus.Paid,
          name: "ทำจ่ายแล้ว",
        },
      ],
    },
    APPROVER_L1: {
      PROPOSAL: ApproverProposalStatusItems,
      CLAIM: ApproverClaimStatusItems,
      ACCOUNTING: [
        {
          id: TicketStatus.All,
          name: "ทั้งหมด",
        },
        {
          id: TicketStatus.AwaitingApproval,
          name: "รออนุมัติการทำจ่าย",
        },
        {
          id: TicketStatus.Approved,
          name: "ทำจ่ายแล้ว",
        },
        {
          id: TicketStatus.Paid,
          name: "ทำจ่ายแล้ว",
        },
      ],
    },
    APPROVER_L2: {
      PROPOSAL: ApproverProposalStatusItems,
      CLAIM: ApproverClaimStatusItems,
    },
    APPROVER_L3: {
      PROPOSAL: ApproverProposalStatusItems,
      CLAIM: ApproverClaimStatusItems,
    },
    APPROVER_L4: {
      PROPOSAL: ApproverProposalStatusItems,
      CLAIM: ApproverClaimStatusItems,
      MANAGEMENT: [
        {
          id: TicketStatus.All,
          name: "ทั้งหมด",
        },
        { id: TicketStatus.AwaitingApproval, name: "รอการอนุมัติทำจ่ายจากคุณ" },
        { id: TicketStatus.AwaitingOther, name: "รอการอนุมัติทำจ่ายจากคนอื่น" },
        { id: TicketStatus.Rejected, name: "ไม่ได้รับการอนุมัติทำจ่าย" },
        { id: TicketStatus.Approved, name: "อนุมัติทำจ่ายแล้ว" },
        { id: TicketStatus.Paid, name: "ทำจ่ายแล้ว" },
      ],
    },
    APPROVER_L5: {
      PROPOSAL: ApproverProposalStatusItems,
      CLAIM: ApproverClaimStatusItems,
      MANAGEMENT: [
        {
          id: TicketStatus.All,
          name: "ทั้งหมด",
        },
        { id: TicketStatus.AwaitingApproval, name: "รอการอนุมัติทำจ่ายจากคุณ" },
        { id: TicketStatus.AwaitingOther, name: "รอการอนุมัติทำจ่ายจากคนอื่น" },
        { id: TicketStatus.Rejected, name: "ไม่ได้รับการอนุมัติทำจ่าย" },
        { id: TicketStatus.Approved, name: "อนุมัติทำจ่ายแล้ว" },
        { id: TicketStatus.Paid, name: "ทำจ่ายแล้ว" },
      ],
    },
  },

  subTicketStatusOption: [
    { id: "ALL", name: "ทั้งหมด" },
    { id: "SUBMITTED", name: "รอการอนุมัติ" },
    { id: "APPROVED", name: "อนุมัติแล้ว" },
    { id: "REJECTED", name: "ปฏิเสธ" },
  ],

  sortOption: [
    { id: "DEFAULT", name: "เริ่มต้น" },
    { id: "CREATED_AT_ASC", name: "วันที่สร้างเก่าสุด" },
    { id: "CREATED_AT_DESC", name: "วันที่สร้างใหม่สุด" },
    { id: "UPDATED_AT_ASC", name: "วันที่แก้ไขเก่าสุด" },
    { id: "UPDATED_AT_DESC", name: "วันที่แก้ไขใหม่สุด" },
  ],

  convertTicketStatusTH: function (status) {
    let rs = "";
    let find_item = this.ticketStatusOption.find((x) => x.id === status);
    if (find_item) {
      rs = find_item.name;
    }
    return rs;
  },

  convertSubTicketStatusTH: function (status) {
    let rs = "";
    let find_item = this.subTicketStatusOption.find((x) => x.id === status);
    if (find_item) {
      rs = find_item.name;
    }
    return rs;
  },
};
export default AppTicketConstant;

export const getStatusDisplayName = (phase, status, approveSequence) => {
  const userRole = AppUserProfile.getData()["role_name"];
  const userId = Number(AppUserProfile.getData()["user_id"]);
  const userRoleLevel = AppUserProfile.getData()["role_level"];
  const rolePhaseOptions =
    AppTicketConstant.ticketStatusOption[userRole]?.[phase];

  if (!rolePhaseOptions) return null;
  const statusOption = rolePhaseOptions.find((option) => {
    return (
      stringToTicketStatus(option.id.value) ===
      approverGetTicketStatus(
        phase,
        status,
        userRole,
        userId,
        userRoleLevel,
        approveSequence
      )
    );
  });

  return statusOption || null;
};

const approverGetTicketStatus = (
  phase,
  status,
  userRole,
  userId,
  userRoleLevel,
  approveSequence
) => {
  if (userRole.includes("APPROVER")) {
    switch (stringToTicketStatus(status)) {
      case TicketStatus.AwaitingApproval:
        return approveSequence.next_approver_user_id === userId &&
          approveSequence.next_approver_level === userRole
          ? TicketStatus.AwaitingApproval
          : TicketStatus.AwaitingOther;
      default:
        return stringToTicketStatus(status);
    }
  }
  return stringToTicketStatus(status);
};
